import { useUpdateProductVisibilityMutation } from "@dashboard/products/api";
import { SelectField } from "@shared/form/SelectField/SelectField";
import { MultipleSelectFieldProps } from "@shared/form/SelectField/SelectField.types";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import { showSuccessToast } from "@shared/toasts/Toasts";

const visibilityOptions = [
    { value: "ExportableBuilds", label: "Exportable builds" },
    { value: "PublicInheritance", label: "Public inheritance" },
    { value: "PublicFirmware", label: "Public firmware" },
    { value: "PublicDeviceRegistration", label: "Public device registration" },
];

export type VisibilityCellProps = { product: API.Product };

export const VisibilityCell = (props: VisibilityCellProps) => {
    // Read straight from the product rather than seeding local state from it: the mutation invalidates "Products",
    // so the refetched list is the source of truth. Local state used to survive that refetch, and because rows are
    // identified by position, a deleted product shifted every row up and left each select showing the previous
    // occupant's flags — with the next change then saved against the product actually rendered there.
    const selectedValues = props.product.visibility ?? [];

    const [updateProductVisibility] = useUpdateProductVisibilityMutation();

    const handleVisibilityChange: MultipleSelectFieldProps["onChange"] = async (_event, selectedOption) => {
        const selectedValuesToSet = selectedOption.map((option) => option.value.toString());
        const result = await updateProductVisibility({ productId: props.product.id, visibility: selectedValuesToSet });
        if (!("error" in result)) {
            showSuccessToast("Visibility updated successfully");
        }
    };

    return (
        <MinimalTableCell>
            <SelectField
                options={visibilityOptions}
                value={visibilityOptions.filter((option) => selectedValues.includes(option.value))}
                onChange={handleVisibilityChange}
                fullWidth
                multiple
            />
        </MinimalTableCell>
    );
};
